<template>
  <WithPagination :is-loading="isLoading" :data="transactions">
    <template #default="{ currentPageData }">
      <ElTable stripe :data="currentPageData">
        <ElTableColumn
          :min-width="120"
          :label="$t('ADVERTISEMENT.TRANSACTIONS.TOTAL_AMOUNT')"
        >
          <template #default="{ row: { total_amount }}">
            {{ currencyFormat(total_amount) }}
            {{ $t('RIALS') }}
          </template>
        </ElTableColumn>
        <ElTableColumn
          :min-width="120"
          :label="$t('ADVERTISEMENT.TRANSACTIONS.CHARGE_AMOUNT')"
        >
          <template #default="{ row: { charge_amount }}">
            {{ currencyFormat(charge_amount) }}
            {{ $t('RIALS') }}
          </template>
        </ElTableColumn>
        <ElTableColumn
          :min-width="100"
          prop="purchase_time"
          :label="$t('ADVERTISEMENT.TRANSACTIONS.PURCHASE_TIME')"
        >
          <template #default="{ row: { purchase_time }}">
            {{ translateDate(purchase_time) }}
          </template>
        </ElTableColumn>
        <ElTableColumn
          :min-width="80"
          :label="$t('ADVERTISEMENT.TRANSACTIONS.STATUS')"
        >
          <template #default="{ row: { status, status_text }}">
            <TransactionsTableStatusColumnContent
              :status="status"
              :status-text="status_text"
            />
          </template>
        </ElTableColumn>
        <ElTableColumn
          :min-width="150"
          :label="$t('ADVERTISEMENT.TRANSACTIONS.TYPE')"
        >
          <template #default="{ row: { type, charge_amount }}">
            <TransactionsTableTypeColumnContent
              :type="type"
              :amount="charge_amount"
            />
          </template>
        </ElTableColumn>
        <ElTableColumn
          :min-width="200"
          prop="order_id"
          :label="$t('ADVERTISEMENT.TRANSACTIONS.ORDER_ID')"
        />
        <ElTableColumn
          v-if="anyInvoiceHasFactor(currentPageData)"
          align="center"
          :min-width="150"
        >
          <template #default="{ row: { has_invoice, invoice_tag }}">
            <TransactionsTableInvoiceColumnContent
              v-if="has_invoice"
              :invoice-tag="invoice_tag"
            />
          </template>
        </ElTableColumn>
      </ElTable>
    </template>
  </WithPagination>
</template>

<script>
import WithPagination from '@@/common/paginations/WithPagination';
import { format as currencyFormat } from '@/utils/number';
import { dateFormat } from '@/utils/date';
import TransactionsTableStatusColumnContent from './TransactionsTableStatusColumnContent';
import TransactionsTableTypeColumnContent from './TransactionsTableTypeColumnContent';
import TransactionsTableInvoiceColumnContent from './TransactionsTableInvoiceColumnContent';

export default {
  name: 'TransactionsTable',
  components: {
    WithPagination,
    TransactionsTableStatusColumnContent,
    TransactionsTableTypeColumnContent,
    TransactionsTableInvoiceColumnContent,
  },
  props: {
    transactions: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    currencyFormat,
    anyInvoiceHasFactor(transactions) {
      return transactions.some(transaction => transaction.has_invoice);
    },
    translateDate(date) {
      let toFormat = 'DD/MM/YYYY HH:mm';

      if (this.lang === 'fa') {
        toFormat = 'jYYYY/jMM/jDD HH:mm';
      }

      return dateFormat()(toFormat)(date);
    },
  },
};
</script>
